import { Archive, ArchiveRestore } from "lucide-react";
import { Button } from "@components/ui/button";
import {
  addNotification,
  deleteNotification,
  getAllNotifications,
  updateAllNotificationsStatus,
  updateNotificationStatus,
  updateNotificationStatus1,
} from "@redux/slices/notifications";
import LoadingScreen from "@components/LoadingScreen";
import { useEffect, useState } from "react";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import * as Select from "@radix-ui/react-select";

interface Notification {
  id: number;
  title: string;
  message: string;
  is_read: boolean;
  status: "current" | "archived" | string;
  created_at: string;
}

export interface AppNotification {
  id: number;
  title: string;
  message: string;
  is_read: boolean;
  status: "current" | "archived";
  created_at: string;
}

const NotificationsPage: React.FC = () => {
  const [notifications, setNotifications] = useState<AppNotification[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedValue, setSelectedValue] = useState<"current" | "archived">(
    "current"
  );

  useEffect(() => {
    setLoading(true);
    fetchNotifications();
  }, [selectedValue]);

  const fetchNotifications = async () => {
    const data: AppNotification[] = (await getAllNotifications()) || [];
    console.log(data);
    if (data) {
      const filteredData: AppNotification[] = data
        .filter((notification) => notification.status === selectedValue)
        .sort((a, b) => (b.is_read === a.is_read ? 0 : b.is_read ? -1 : 1));
  
      setNotifications(filteredData);
      console.log(filteredData);
      console.log("I am here")
    }
    setLoading(false);
  };
  
  const handleMarkAsRead = async (id: number) => {
    setLoading(true);
    await updateNotificationStatus(id, true);
    fetchNotifications();
  };

  const handleArchive = async (id: number) => {
    setLoading(true);
    await updateNotificationStatus1(id, "archived");
    fetchNotifications();
  };

  const handleCurrent = async (id: number) => {
    setLoading(true);
    await updateNotificationStatus1(id, "current");
    fetchNotifications();
  };

  const handleMarkAllAsRead = async () => {
    setLoading(true);
    await updateAllNotificationsStatus();
    fetchNotifications();
  };

  const handleAddNotification = async () => {
    await addNotification("New Notification", "This is a new notification.");
    fetchNotifications();
  };

  const handleDeleteNotification = async (id: number) => {
    await deleteNotification(id);
    fetchNotifications();
  };

  return (
    <div>
      <div className="md:flex justify-between items-center my-7">
        <div className="md:me-2 md:w-72 md:mb-0 mb-4">
          <Select.Root
            value={selectedValue}
            onValueChange={(value) =>
              setSelectedValue(value as "current" | "archived")
            }
          >
            <SelectTrigger
              className="SelectTrigger bg-white border-none"
              aria-label="Filter"
            >
              <SelectValue placeholder="Select" />
            </SelectTrigger>
            <SelectContent className="SelectContent">
              <SelectItem value="current">Current</SelectItem>
              <SelectItem value="archived">Archived</SelectItem>
            </SelectContent>
          </Select.Root>
        </div>
        <Button onClick={handleMarkAllAsRead}>Mark all as read</Button>
      </div>

      <div className="bg-white rounded-lg sm:p-8 p-6">
        <h2 className="text-gray font-bold sm:text-[24px] text-lg mb-4">
          Notifications
        </h2>
        {loading ? (
          <LoadingScreen />
        ) : (
          notifications.map((notification) => (
            <div
              className="flex justify-between border-b py-2 mt-4"
              key={notification.id}
            >
              <div>
                <div className="flex">
                  <h5 className="text-lg font-semibold mb-4">
                    {notification.title}
                  </h5>
                  {!notification.is_read && (
                    <div className="bg-lime-500 px-3 mt-1 h-fit rounded-full font-semibold text-white ms-4">
                      Unread
                    </div>
                  )}
                </div>
                <p>{notification.message}</p>
              </div>
              <div>
                <div className="flex items-center justify-end text-right mb-4">
                  {notification.status === "current" ? (
                    <Archive
                      size={20}
                      className="cursor-pointer me-4"
                      onClick={() => handleArchive(notification.id)}
                    />
                  ) : (
                    <ArchiveRestore
                      size={20}
                      className="cursor-pointer me-4"
                      onClick={() => handleCurrent(notification.id)}
                    />
                  )}
                  {!notification.is_read && (
                    <p
                      className="font-medium underline pb-1 cursor-pointer"
                      onClick={() => handleMarkAsRead(notification.id)}
                    >
                      Mark as Read
                    </p>
                  )}
                </div>
                <div className="text-md text-gray text-right">
                  {notification.created_at}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationsPage;
